import { VideoElement, VideoScene } from "../../../VideoEditor/types/Video";
import { v4 as uuid } from "uuid";
import { Template } from "../types";
import { defaultSequenceDuration } from "../../../constants";

export function generateOnboardingIntroductionTemplate(
  data: Template,
  order: number,
  t: any
) {
  const sceneId = uuid();
  const scene: VideoScene = {
    id: sceneId,
    backgroundColor: "#fff",
    duration: defaultSequenceDuration,
    order,
    name: t("themi-builder.template.introduction.scene-name"),
    enableCollaboration: true,
    start_time: 0,
    elements: [],
  };

  const firstElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    text: `<p style="font-family: Arial; font-size: 4.57cqw;"><strong>${t(
      "themi-builder.template.onboarding-introduction.title"
    )}</strong></p>`,
    type: "text",
    order: 0,
    states: [
      {
        id: uuid(),
        top: 21.21,
        left: 35.35,
        scale: 1,
        width: 451.5239565943239,
        height: 102.56994818652849,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
  };

  const secondElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    // Give a short introduction on the company and the team the new starter is joining. Duplicate this sequence to add more context.
    text: `<p style="font-family: Arial; font-size: 2cqw; color: rgba(97, 97, 97, 1);">${t(
      "themi-builder.template.onboarding-introduction.description"
    )}</p>`,
    type: "text",
    order: 1,
    states: [
      {
        id: uuid(),
        top: firstElement.states[0].top + firstElement.states[0].height + 10,
        left: 35.35,
        scale: 1,
        width: 450.3436560934892,
        height: 44.85141903171953,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
  };

  const thirdElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    // To introduce the company and team, answer questions such as:
    // What is the company's vision and strategy?
    // What is the team the new starter is joining, and how does the team fit in the overall company?
    // What are the team's priorities for the next year?
    // Where can the new starter find more information on the company?
    text: `<ul>
    <li style="font-family: Arial; font-size: 2cqw; color: rgba(97, 97, 97, 1);">${t(
      "themi-builder.template.onboarding-introduction.points.one"
    )}</li>
    <li style="font-family: Arial; font-size: 2cqw; color: rgba(97, 97, 97, 1);">${t(
      "themi-builder.template.onboarding-introduction.points.two"
    )}</li>
    <li style="font-family: Arial; font-size: 2cqw; color: rgba(97, 97, 97, 1);">${t(
      "themi-builder.template.onboarding-introduction.points.three"
    )}</li>
    <li style="font-family: Arial; font-size: 2cqw; color: rgba(97, 97, 97, 1);">${t(
      "themi-builder.template.onboarding-introduction.points.four"
    )}</li>
    <li style="font-family: Arial; font-size: 2cqw; color: rgba(97, 97, 97, 1);">${t(
      "themi-builder.template.onboarding-introduction.points.five"
    )}</li>
    </ul>`,
    type: "text",
    order: 2,
    states: [
      {
        id: uuid(),
        top: 194.41762312186978,
        left: 36.530300500834706,
        scale: 1,
        width: 467.4580133555927,
        height: 144.58681135225376,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
  };

  const fourthElement: VideoElement = {
    id: uuid(),
    scene_id: sceneId,
    type: "record-prompt",
    order: 3,
    states: [
      {
        id: uuid(),
        top: 42.98728192821372,
        left: 522.2829716193656,
        scale: 1,
        width: 145.2300751252091,
        height: 44.7002139338096,
        duration: defaultSequenceDuration,
        rotation: 0,
        start_time: 0,
      },
    ],
    instruction: t("themi-builder.template.record-prompt.general-description"),
  };

  const scenes: VideoScene[] = [scene];

  const elements: VideoElement[] = [
    firstElement,
    secondElement,
    thirdElement,
    fourthElement,
  ];

  return { scenes, elements };
}
